export default {
    patentReview: {
        list: {
            title: '核稿任务',
            newTask: '+ 新建核稿',
            empty: '暂无核稿任务',
            emptyHint: '上传专利初稿文件，即可开始形式核稿',
            rules: '条规则',
            tabTasks: '核稿任务列表',
            tabRules: '自定义规则管理',
        },
        status: {
            pending: '待处理',
            running: '执行中',
            completed: '已完成',
            failed: '失败',
        },
        steps: {
            '1_parsing': '解析文件',
            '2_extracting': '提取四要素',
            '3_figure_analysis': '附图分析',
            '4_formal_check': '形式审查',
            '5_substantive_check': '实质审查',
            '6_finalizing': '最终报告',
        },
        stepStatus: {
            done: '已完成',
            running: '执行中',
            failed: '失败',
            pending: '等待中',
        },
        consistencyStep: {
            title: '交底一致性',
        },
        stabilityStep: {
            title: '稳定性分析',
        },
        upload: {
            title: '新建核稿任务',
            mainFile: {
                title: '上传申请初稿',
                hint: 'PDF、DOCX',
            },
            figureSection: {
                addButton: '附图',
                title: '附图',
                hint: '支持拖拽或多选上传',
            },
            disclosureSection: {
                addButton: '技术交底书',
                title: '技术交底书',
                hint: '支持拖拽或多选上传',
            },
            customRulesSection: {
                addButton: '自定义规则',
                title: '自定义规则',
                dialogTitle: '自定义规则库',
                searchPlaceholder: '搜索规则库名称',
                historyGroup: '历史规则库',
                newGroup: '本次新上传',
                uploadButton: '上传规则',
                uploadFormats: '支持 .docx / .pdf / .pptx',
                confirm: '确认选择',
                empty: '暂无规则库，点击"上传规则"添加',
                rulesEmpty: '该规则库未提取出规则',
                loadFailed: '加载规则库列表失败，请重试',
                uploadFailed: '上传规则文件失败，请重试',
            },
            patentOffice: '受理局',
            officeHint: '切换后自动匹配对应法条与审查基准',
            officeComingSoon: '即将推出',
            patentType: {
                label: '专利类型',
                invention: '发明',
                utility: '实用新型',
            },
            ruleType: {
                label: '规则类型',
                official: '官方规则',
                officialCustom: '官方规则+自定义规则',
            },
            chooseFile: '选择文件',
            fileHint: '支持 .docx / .pdf，最多 {max} 个文件',
            confirm: '开始审查',
            uploading: '正在上传…',
            cancel: '取消',
            removeFile: '移除',
        },
        detail: {
            backToList: '返回列表',
            taskHeader: {
                entry: '核稿审查',
                projectPackage: '专利审查项目包',
                unnamedTask: '未命名任务',
                progressTitle: '审查进度',
                autoRun: '自动运行',
                exportReport: '导出报告',
                exportNotReady: '核稿完成后可导出',
                finalizingCardSubtitle: '汇总结论',
                stepsExecutedCaption: '四项流程已执行',
                parsingCaption: '解析中',
                issueCountSuffix: '{count} 项问题',
            },
            materials: {
                mainFileTag: '专利申请文件',
                figureTag: '附图',
                disclosureTag: '交底书',
                attachmentTag: '附件',
            },
            parsing: {
                fileName: '文件名',
                fileNamePending: '正在识别主文件…',
                hint: '正在解析上传文件的文本内容…',
            },
            extracting: {
                title: '发明名称',
                abstract: '摘要',
                claims: '权利要求书',
                specification: '说明书',
                figures: '附图',
                expand: '展开',
                collapse: '收起',
                empty: '暂无内容',
            },
            check: {
                pass: '通过',
                passCollapsed: '通过（{count} 条）',
                filterAll: '全部',
                filterInfo: '提示',
                filterWarning: '警告',
                filterError: '错误',
                filterCritical: '严重',
                location: '位置',
                suggestion: '修改建议',
                guidelineSource: '依据来源',
                empty: '暂无形式核稿问题',
                summaryPattern: '发现 {count} 处可定位的形式或企业规范问题',
                statTitle: '发现{count}处形式问题，其中，{officialCount}项违反官方规则，{customCount}项违反企业规则。',
                statFormalIssues: '形式问题',
                statOfficialViolations: '违反官方规则',
                statCustomViolations: '违反企业规则',
                summaryTitle: '形式检查·总结结论',
                summaryRequireModify: '{count}项需修改',
                summaryRequireConfirm: '{count}项需人工确认',
                summaryStats: '共{total}条规则·{requireModify}项·{requireConfirm}项·{pass}项已通过',
                systemRules: '系统规则',
                customRules: '企业规则',
                legendPass: '通过',
                legendFail: '不通过',
                legendPending: '需人工确认',
                summaryAllPassed: '全部通过',
                coverageTitle: '规则覆盖',
                coverageSource: '规则来源',
                coverageTotal: '规则数',
                coverageFail: '不通过',
                coverageVerify: '待确认',
                coveragePending: '待核查',
                coveragePassed: '通过',
            },
            table: {
                tabIssues: '问题定位表',
                tabCoverage: '检查覆盖',
                sourceOfficial: '官方规则',
                sourceCustom: '企业规则',
                sourceCustomEmpty: '暂无企业自定义规则命中数据',
                searchPlaceholder: '搜索权项、问题或法条',
                columnIndex: '#',
                columnLocation: '具体位置',
                columnIssue: '检查结果/问题',
                columnStatute: '适用法条/规则依据',
                columnSuggestion: '修改建议',
                columnEvidence: '证据',
                evidenceEmpty: '—',
                statusPending: '需修改',
                statusApplied: '已修改',
                statusIgnored: '已忽略',
                statusPass: '已通过',
                coverageColumnType: '规则类型',
                coverageColumnRule: '检查规则',
                coverageColumnContent: '规则内容',
                coverageColumnResult: '检查结果',
                coverageResultEmpty: '—',
                coverageResultFound: '发现问题',
                ruleTypeOfficial: '官方规则',
                ruleTypeCustom: '企业规则',
                itemUnit: '项',
                columnPatentSection: '专利章节',
                columnCheckRule: '检查规则',
                columnCheckResult: '检查结果',
                columnErrorReason: '错误理由',
                editButton: '编辑',
                adoptButton: '采纳改文',
                locateButton: '错误定位',
                locationModalTitle: '错误定位',
                locationModalContent: '定位信息：{location}',
                locationModalClose: '关闭',
                locationModalRuleLabel: '检查规则',
                locationModalLocationLabel: '位置',
                locationModalSuggestionLabel: '修改建议',
                locationModalBoundaryLabel: '适用边界',
                locationModalSourceTitle: '原稿内容',
                locationModalPositionUnresolved: '未能确定错误位置',
                statusRequireModify: '需修改',
                statusRequireConfirm: '需人工确认',
                statusPendingVerification: '待核查',
            },
            finalizing: {
                conclusion: '总体结论',
                totalRules: '规则总数',
                passCount: '通过',
                warningCount: '警告',
                errorCount: '错误',
                criticalCount: '严重错误',
                conclusions: {
                    formal: '形式核稿结论',
                    art26_3: '第26条第3款结论',
                    art26_4: '第26条第4款结论',
                },
                riskMatrix: {
                    title: '实质核稿风险等级分布',
                    high: '高风险',
                    medium: '中风险',
                    low: '低风险',
                },
                conclusionValue: {
                    compliant: '符合',
                    risky: '基本符合但有风险',
                    non_compliant: '可能不符合',
                    insufficient: '材料不足无法完整判断',
                },
                dimensionConclusions: {
                    title: '检查维度结论',
                    unresolved: '未判定',
                },
            },
            featureMapping: {
                figuresNone: '本申请未包含附图',
                figuresFailed: '附图识别未完成，本次判断未结合附图内容',
                figureNoLabel: '图{no}',
                figureNoUnknown: '图号未标注',
                figureConfidenceMedium: '图号为推断结果',
                figureConfidenceLow: '图号无法确定',
                figureSignsLabel: '图面标引',
                figureNoSigns: '图面未见标引',
            },
            substantive: {
                filterHigh: '高风险',
                filterMedium: '中风险',
                filterLow: '低风险',
                filterAll: '全部',
                needsInventorConfirm: '需发明人确认',
                boundaryLabel: '适用边界',
                summaryPattern: '发现 {count} 处实质性问题，建议逐项核实',
                issuesLocations: '形式问题定位',
                title: '实质审查',
                checkResultTitle: '检查结果',
                issuesCount: '实质问题',
                highRiskCount: '高风险问题',
            },
            supplement: {
                title: '必要补充材料清单',
                columns: {
                    content: '需补充内容',
                    reason: '原因',
                    targetStatute: '用于解决的法条问题',
                    suggestedLocation: '建议补充位置',
                },
                empty: '暂无必要补充材料',
            },
            failed: {
                retryHint: '核稿任务执行失败，可返回列表重新上传文件',
            },
            reportLoadFailed: {
                message: '加载核稿报告失败，请重试',
                retry: '重新加载',
            },
            stepRunning: '该步骤正在执行，完成后可查看结果…',
            noStepSelected: '请选择一个步骤查看详情',
        },
        customRuleDocuments: {
            delete: '删除',
            deleteConfirm: '确认删除？',
            confirmYes: '确认',
            confirmNo: '取消',
            empty: '暂无规则文档',
            rulesEmpty: '该文档未提取出规则',
            rulesLoadFailed: '加载规则明细失败，请重试',
            rulesCount: '{count} 条规则',
            status: {
                uploaded: '已上传',
                parsing: '解析中',
                parsed: '已解析',
                parse_failed: '解析失败',
            },
            upload: {
                title: '上传规则文档',
                addButton: '上传规则文档',
                fileTitle: '上传规则文档',
                fileHint: 'PDF、DOCX',
                chooseFile: '选择文件',
                removeFile: '移除',
                confirm: '开始上传',
                uploading: '正在上传…',
            },
            loadFailed: '加载规则文档失败，请重试',
            uploadFailed: '上传规则文档失败，请重试',
            updateFailed: '更新失败，请重试',
            deleteSuccess: '删除成功',
            deleteFailed: '删除失败，请重试',
        },
        errors: {
            createTaskFailed: '创建核稿任务失败，请重试',
            loadTaskFailed: '加载任务状态失败，请重试',
            loadReportFailed: '加载核稿报告失败，请重试',
            loadTasksFailed: '加载任务列表失败，请重试',
            unsupportedOffice: '暂不支持该受理局',
            exportReportFailed: '导出核稿报告失败，请重试',
        },
    },
};
